/* RICLABNAIL theme interactivity — vanilla JS, no dependencies. */
(function () {
  "use strict";

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------------------------------------------- Announcement bar */
  document.querySelectorAll("[data-announcement]").forEach(function (bar) {
    var messages = JSON.parse(bar.getAttribute("data-announcement"));
    if (!messages.length) return;
    var index = 0;
    var text = bar.querySelector("[data-announcement-text]");
    function show(next) {
      index = (next + messages.length) % messages.length;
      text.textContent = messages[index];
    }
    bar.querySelector("[data-announcement-prev]").addEventListener("click", function () { show(index - 1); });
    bar.querySelector("[data-announcement-next]").addEventListener("click", function () { show(index + 1); });
    if (!reducedMotion && messages.length > 1) {
      setInterval(function () { show(index + 1); }, 5000);
    }
  });

  /* ----------------------------------------------------- Header + drawers */
  var megaButtons = Array.prototype.slice.call(document.querySelectorAll("[data-mega-toggle]"));
  var megaMenus = Array.prototype.slice.call(document.querySelectorAll("[data-mega-menu]"));
  var mobileToggle = document.querySelector("[data-mobile-toggle]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");
  var mobileBackdrop = document.querySelector("[data-mobile-backdrop]");

  function setMega(open, id) {
    megaMenus.forEach(function (menu) {
      var isTarget = open && menu.getAttribute("data-mega-menu") === id;
      menu.classList.toggle("is-open", isTarget);
      menu.setAttribute("aria-hidden", isTarget ? "false" : "true");
      if (isTarget) { menu.removeAttribute("inert"); } else { menu.setAttribute("inert", ""); }
    });
    megaButtons.forEach(function (button) {
      var isTarget = open && button.getAttribute("data-mega-toggle") === id;
      button.classList.toggle("is-active", isTarget);
      button.setAttribute("aria-expanded", isTarget ? "true" : "false");
    });
  }
  function setMobile(open) {
    if (!mobileMenu) return;
    mobileMenu.classList.toggle("is-open", open);
    mobileMenu.setAttribute("aria-hidden", open ? "false" : "true");
    if (open) { mobileMenu.removeAttribute("inert"); } else { mobileMenu.setAttribute("inert", ""); }
    mobileBackdrop.classList.toggle("is-open", open);
    mobileToggle.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.style.overflow = open ? "hidden" : "";
  }
  megaButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var id = button.getAttribute("data-mega-toggle");
      setMega(!button.classList.contains("is-active"), id);
    });
  });
  document.addEventListener("click", function (event) {
    if (!event.target.closest("[data-mega-toggle], [data-mega-menu]")) setMega(false);
  });
  if (mobileToggle) mobileToggle.addEventListener("click", function () { setMobile(!mobileMenu.classList.contains("is-open")); });
  if (mobileBackdrop) mobileBackdrop.addEventListener("click", function () { setMobile(false); });
  document.querySelectorAll("[data-mobile-close]").forEach(function (button) {
    button.addEventListener("click", function () { setMobile(false); });
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      var activeMegaButton = document.querySelector("[data-mega-toggle].is-active");
      setMega(false);
      setMobile(false);
      setCart(false);
      if (activeMegaButton) activeMegaButton.focus();
    }
  });

  /* ---------------------------------------------------------- Cart drawer */
  function cartDrawer() { return document.querySelector("[data-cart-drawer]"); }
  function cartBackdrop() { return document.querySelector("[data-cart-backdrop]"); }
  function setCart(open) {
    var drawer = cartDrawer();
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    if (open) { drawer.removeAttribute("inert"); } else { drawer.setAttribute("inert", ""); }
    cartBackdrop().classList.toggle("is-open", open);
  }
  function bindCartOpeners() {
    document.querySelectorAll("[data-cart-open]").forEach(function (button) {
      button.addEventListener("click", function (event) { event.preventDefault(); setCart(true); });
    });
  }
  function bindCartDrawer() {
    var drawer = cartDrawer();
    if (!drawer) return;
    drawer.querySelectorAll("[data-cart-close]").forEach(function (button) {
      button.addEventListener("click", function () { setCart(false); });
    });
    cartBackdrop().addEventListener("click", function () { setCart(false); });
    drawer.querySelectorAll("[data-cart-change]").forEach(function (button) {
      button.addEventListener("click", function () {
        changeCart({line: Number(button.getAttribute("data-line")), quantity: Number(button.getAttribute("data-quantity"))});
      });
    });
  }
  function refreshCartSection(openAfter) {
    return fetch(window.Shopify.routes.root + "?sections=cart-drawer")
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        var holder = document.createElement("div");
        holder.innerHTML = sections["cart-drawer"];
        var fresh = holder.querySelector("[data-cart-root]");
        var current = document.querySelector("[data-cart-root]");
        current.replaceWith(fresh);
        bindCartDrawer();
        document.querySelectorAll("[data-cart-count]").forEach(function (badge) {
          badge.textContent = fresh.getAttribute("data-item-count");
        });
        if (openAfter) setCart(true);
      });
  }
  // Mũi tên carousel Featured items: bắt ở document vì drawer render lại sau
  // mỗi lần đổi giỏ, bind trực tiếp sẽ mất listener.
  document.addEventListener("click", function (event) {
    var arrow = event.target.closest("[data-cart-featured-scroll]");
    if (!arrow) return;
    var block = arrow.closest("[data-cart-featured]");
    var track = block ? block.querySelector("[data-cart-featured-track]") : null;
    if (!track) return;
    var card = track.querySelector(".cart-featured-item");
    var step = card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
    track.scrollBy({left: step * Number(arrow.getAttribute("data-cart-featured-scroll")), behavior: "smooth"});
  });

  function changeCart(payload) {
    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(payload),
    }).then(function () { refreshCartSection(true); });
  }
  document.addEventListener("submit", function (event) {
    var form = event.target.closest("form[data-ajax-add]");
    if (!form) return;
    event.preventDefault();
    // Nút mobile nằm ngoài form và gắn vào bằng form=, nên querySelector trong
    // form không thấy nó; phải khoá/mở riêng để không bấm được hai lần.
    var button = form.querySelector("[type=submit]");
    var mobileButton = form.closest("[data-product-form]") ? document.querySelector("[data-mobile-add]") : null;
    if (button) button.disabled = true;
    if (mobileButton) mobileButton.disabled = true;
    fetch(window.Shopify.routes.root + "cart/add.js", {method: "POST", body: new FormData(form)})
      .then(function (response) { return response.json(); })
      .then(function (result) {
        if (result.status && result.status !== 200) throw new Error(result.description || "Add to cart failed");
        return refreshCartSection(true);
      })
      .catch(function (error) { console.error(error); window.location.href = window.Shopify.routes.root + "cart"; })
      .finally(function () {
        if (button) button.disabled = false;
        if (mobileButton) mobileButton.disabled = false;
      });
  });
  bindCartOpeners();
  bindCartDrawer();

  /* -------------------------------------------------- Product option form */
  document.querySelectorAll("[data-product-form]").forEach(function (wrapper) {
    var variants = JSON.parse(wrapper.querySelector("[data-variants-json]").textContent);
    var idInput = wrapper.querySelector("[data-variant-id]");
    var priceLabel = wrapper.querySelector("[data-variant-price]");
    var addButton = wrapper.querySelector("[data-add-button]");
    var addLabel = addButton ? addButton.querySelector("[data-add-label]") : null;
    var mobileAddButton = document.querySelector("[data-mobile-add]");
    var mobilePriceLabel = document.querySelector("[data-mobile-price]");
    var moneyFormat = wrapper.getAttribute("data-money-format");

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, "");
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }
    function selections() {
      var chosen = {};
      wrapper.querySelectorAll("[data-option-picker]").forEach(function (picker) {
        var selected = picker.querySelector("button[data-value].selected");
        chosen[picker.getAttribute("data-option-name")] = selected ? selected.getAttribute("data-value") : null;
      });
      return chosen;
    }
    function matchVariant(chosen) {
      return variants.find(function (variant) {
        return Object.keys(chosen).every(function (name) {
          var index = Number(wrapper.querySelector('[data-option-name="' + CSS.escape(name) + '"]').getAttribute("data-option-index"));
          return variant.options[index] === chosen[name];
        });
      });
    }
    function updateAvailability(chosen) {
      wrapper.querySelectorAll("[data-option-picker]").forEach(function (picker) {
        var name = picker.getAttribute("data-option-name");
        picker.querySelectorAll("button[data-value]").forEach(function (button) {
          var trial = Object.assign({}, chosen);
          trial[name] = button.getAttribute("data-value");
          var available = variants.some(function (variant) {
            return variant.available && Object.keys(trial).every(function (trialName) {
              var trialIndex = Number(wrapper.querySelector('[data-option-name="' + CSS.escape(trialName) + '"]').getAttribute("data-option-index"));
              return variant.options[trialIndex] === trial[trialName];
            });
          });
          button.classList.toggle("unavailable", !available);
        });
      });
    }
    // addLabel giữ toàn bộ chuỗi trạng thái nút; nó có thể vắng nếu form đổi
    // cấu trúc nên mọi nơi đọc chuỗi đều phải chịu được giá trị rỗng.
    function labelText(attribute) {
      return addLabel ? addLabel.getAttribute(attribute) : "";
    }
    function sync() {
      var chosen = selections();
      var variant = matchVariant(chosen);
      updateAvailability(chosen);
      if (variant) {
        idInput.value = variant.id;
        if (priceLabel) priceLabel.textContent = formatMoney(variant.price);
        if (mobilePriceLabel) mobilePriceLabel.textContent = formatMoney(variant.price);
        if (addButton) addButton.disabled = !variant.available;
        var availableText = labelText(variant.available ? "data-text-add" : "data-text-soldout");
        if (addLabel) addLabel.textContent = availableText;
        if (mobileAddButton) {
          mobileAddButton.disabled = !variant.available;
          if (availableText) mobileAddButton.textContent = availableText;
        }
      } else {
        if (addButton) addButton.disabled = true;
        var unavailableText = labelText("data-text-unavailable");
        if (addLabel) addLabel.textContent = unavailableText;
        if (mobileAddButton) {
          mobileAddButton.disabled = true;
          if (unavailableText) mobileAddButton.textContent = unavailableText;
        }
      }
    }
    // Chỉ button có data-value mới là option swatch; nút phụ trong legend (size guide) phải bỏ qua.
    wrapper.querySelectorAll("[data-option-picker]").forEach(function (picker) {
      picker.querySelectorAll("button[data-value]").forEach(function (button) {
        button.addEventListener("click", function () {
          picker.querySelectorAll("button[data-value]").forEach(function (candidate) {
            candidate.classList.toggle("selected", candidate === button);
            candidate.setAttribute("aria-pressed", candidate === button ? "true" : "false");
          });
          sync();
        });
      });
    });
    sync();
  });

  /* --------------------------------------------------- Custom size toggle */
  document.querySelectorAll("[data-custom-size]").forEach(function (wrapper) {
    var toggle = wrapper.querySelector("[data-custom-size-toggle]");
    var field = wrapper.querySelector("[data-custom-size-field]");
    if (!toggle || !field) return;
    var textarea = field.querySelector("textarea");
    function sync() {
      field.hidden = !toggle.checked;
      if (!textarea) return;
      textarea.disabled = !toggle.checked;
      if (!toggle.checked) textarea.value = "";
      else textarea.focus();
    }
    toggle.addEventListener("change", sync);
    field.hidden = !toggle.checked;
    if (textarea) textarea.disabled = !toggle.checked;
  });

  /* ------------------------------------------------------ Quantity stepper */
  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-quantity-step]");
    if (!button) return;
    var input = button.parentElement.querySelector("input[name=quantity]");
    var next = Number(input.value) + Number(button.getAttribute("data-quantity-step"));
    input.value = Math.min(10, Math.max(1, next));
    var label = button.parentElement.querySelector("[data-quantity-label]");
    if (label) label.textContent = input.value;
  });

  /* --------------------------------------------------------- PDP gallery */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var mainImage = gallery.querySelector("[data-gallery-main] img");
    var indexLabel = gallery.querySelector("[data-gallery-index]");
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll(".pdp-thumbs button"));
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () {
        mainImage.src = thumb.getAttribute("data-src");
        mainImage.alt = thumb.getAttribute("data-alt");
        thumbs.forEach(function (candidate) {
          candidate.classList.toggle("is-active", candidate === thumb);
          candidate.setAttribute("aria-pressed", candidate === thumb ? "true" : "false");
        });
        if (indexLabel) indexLabel.textContent = String(i + 1).padStart(2, "0") + " / " + String(thumbs.length).padStart(2, "0");
      });
      thumb.addEventListener("keydown", function (event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          thumb.click();
        }
      });
    });
  });

  /* ----------------------------------------------------- Size guide modal */
  /* Dùng event delegation để modal vẫn chạy sau khi Theme Editor render lại section. */
  var sizeGuideOpener = null;

  function sizeGuideBackdropFor(modal) {
    var previous = modal.previousElementSibling;
    return previous && previous.hasAttribute("data-size-guide-backdrop") ? previous : null;
  }
  function focusableIn(modal) {
    return Array.prototype.filter.call(
      modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'),
      function (node) { return node.offsetParent !== null; }
    );
  }
  function openSizeGuide(modal, opener) {
    var backdrop = sizeGuideBackdropFor(modal);
    sizeGuideOpener = opener || null;
    if (backdrop) backdrop.hidden = false;
    modal.hidden = false;
    // Buộc reflow để transition chạy từ trạng thái đóng.
    void modal.offsetWidth;
    modal.classList.add("is-open");
    if (backdrop) backdrop.classList.add("is-open");
    document.body.style.overflow = "hidden";
    var closeButton = modal.querySelector("[data-size-guide-close]");
    if (closeButton) closeButton.focus();
  }
  function closeSizeGuide(modal) {
    var backdrop = sizeGuideBackdropFor(modal);
    modal.classList.remove("is-open");
    if (backdrop) backdrop.classList.remove("is-open");
    document.body.style.overflow = "";
    var finish = function () {
      modal.hidden = true;
      if (backdrop) backdrop.hidden = true;
    };
    if (reducedMotion) { finish(); } else { window.setTimeout(finish, 280); }
    if (sizeGuideOpener && document.contains(sizeGuideOpener)) sizeGuideOpener.focus();
    sizeGuideOpener = null;
  }
  function openSizeGuideModal() {
    return document.querySelector("[data-size-guide-modal].is-open");
  }

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-size-guide-open]");
    if (opener) {
      var modal = document.getElementById(opener.getAttribute("aria-controls"));
      if (modal) {
        event.preventDefault();
        openSizeGuide(modal, opener);
      }
      return;
    }
    var closer = event.target.closest("[data-size-guide-close]");
    if (closer) {
      closeSizeGuide(closer.closest("[data-size-guide-modal]"));
      return;
    }
    var active = openSizeGuideModal();
    // Click ra ngoài panel (backdrop hoặc vùng đệm của modal) thì đóng.
    if (active && (event.target.hasAttribute("data-size-guide-backdrop") || event.target === active)) {
      closeSizeGuide(active);
    }
  });

  document.addEventListener("keydown", function (event) {
    var active = openSizeGuideModal();
    if (!active) return;
    if (event.key === "Escape") {
      event.stopPropagation();
      closeSizeGuide(active);
      return;
    }
    if (event.key !== "Tab") return;
    var items = focusableIn(active);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (!active.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  /* --------------------------------------------------------- Box builder */
  document.querySelectorAll("[data-box-builder]").forEach(function (builder) {
    builder.querySelectorAll("[data-builder-group]").forEach(function (group) {
      var input = builder.querySelector('input[name="properties[' + group.getAttribute("data-builder-group") + ']"]');
      group.querySelectorAll("button").forEach(function (button) {
        button.addEventListener("click", function () {
          group.querySelectorAll("button").forEach(function (candidate) {
            candidate.classList.toggle("selected", candidate === button);
          });
          if (input) input.value = button.getAttribute("data-value");
          var summary = builder.querySelector("[data-builder-summary]");
          if (summary) {
            var values = Array.prototype.map.call(builder.querySelectorAll("[data-builder-group] button.selected"), function (selected) {
              return selected.getAttribute("data-value");
            });
            summary.textContent = values.join(" · ");
          }
        });
      });
    });
  });

  /* ------------------------------------------------------- Order tracking */
  document.querySelectorAll("[data-order-tracking]").forEach(function (form) {
    var input = form.querySelector("[data-tracking-input]");
    var error = form.querySelector("[data-tracking-error]");
    var panel = form.closest("[data-tracking-panel]");
    var result = panel ? panel.querySelector("[data-tracking-result]") : null;
    var link = result ? result.querySelector("[data-tracking-link]") : null;
    var template = form.getAttribute("data-tracking-url") || "";
    if (template.indexOf("[number]") === -1) return;

    form.addEventListener("submit", function (event) {
      var number = (input.value || "").trim().replace(/\s+/g, "");
      if (!number) return;
      event.preventDefault();
      if (!/^[A-Za-z0-9-]{6,40}$/.test(number)) {
        if (error) error.hidden = false;
        input.focus();
        return;
      }
      if (error) error.hidden = true;
      var url = template.replace("[number]", encodeURIComponent(number));
      if (link) {
        link.setAttribute("href", url);
        if (result) result.hidden = false;
      }
      window.open(url, "_blank", "noopener");
    });

    input.addEventListener("input", function () {
      if (error) error.hidden = true;
    });
  });

  /* --------------------------------------------------- Order tracking tabs */
  document.querySelectorAll(".order-tracking-panel").forEach(function (wrapper) {
    var tabs = Array.prototype.slice.call(wrapper.querySelectorAll("[data-tracking-tab]"));
    var panels = Array.prototype.slice.call(wrapper.querySelectorAll("[data-tracking-panel]"));
    if (tabs.length < 2) return;

    function activate(name, focus) {
      tabs.forEach(function (tab) {
        var isTarget = tab.getAttribute("data-tracking-tab") === name;
        tab.setAttribute("aria-selected", isTarget ? "true" : "false");
        tab.tabIndex = isTarget ? 0 : -1;
        if (isTarget && focus) tab.focus();
      });
      panels.forEach(function (item) {
        item.hidden = item.getAttribute("data-tracking-panel") !== name;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener("click", function () { activate(tab.getAttribute("data-tracking-tab")); });
      tab.addEventListener("keydown", function (event) {
        if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
        event.preventDefault();
        var step = event.key === "ArrowRight" ? 1 : -1;
        var next = tabs[(index + step + tabs.length) % tabs.length];
        activate(next.getAttribute("data-tracking-tab"), true);
      });
    });
  });
})();

/* Customer review archive rendered as progressive, accessible cards. */
(function () {
  "use strict";

  function textNode(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = text || "";
    return node;
  }

  // Huy hiệu "đã xác minh": ảnh badge của store, tỉ lệ 5:1 (480×96 gốc).
  function verifiedBadge(tag, className, src, label) {
    var badge = textNode(tag, className);
    var image = document.createElement("img");
    image.src = src;
    image.alt = label;
    image.width = 480;
    image.height = 96;
    image.loading = "lazy";
    image.decoding = "async";
    badge.appendChild(image);
    return badge;
  }

  function renderImportedReviews(section) {
    if (section.dataset.reviewsReady === "true") return;
    section.dataset.reviewsReady = "true";

    var grid = section.querySelector("[data-reviews-grid]");
    var status = section.querySelector("[data-reviews-status]");
    var summary = section.querySelector("[data-reviews-summary]");
    var more = section.querySelector("[data-reviews-more]");
    var initialCount = Number(section.getAttribute("data-initial-count")) || 12;
    var batchCount = Number(section.getAttribute("data-batch-count")) || 12;
    var showMedia = section.getAttribute("data-show-media") === "true";
    var showProduct = section.getAttribute("data-show-product") === "true";
    var productLabel = section.getAttribute("data-product-label") || "Shop the look";
    var readMoreLabel = section.getAttribute("data-read-more-label") || "Read full review";
    var viewProductLabel = section.getAttribute("data-view-product-label") || "View product";
    var closeReviewLabel = section.getAttribute("data-close-review-label") || "Close review";
    var verifiedBadgeSrc = section.getAttribute("data-verified-badge") || "";
    var verifiedLabel = section.getAttribute("data-verified-label") || "Verified by Shopify";
    var productData = section.querySelector("[data-review-products]");
    var shopProducts = [];
    var reviews = [];
    var visibleCount = 0;
    var dialogTrigger = null;
    var dialog = document.createElement("dialog");
    dialog.className = "imported-review-dialog";
    dialog.setAttribute("aria-label", "Customer review");
    section.appendChild(dialog);

    if (productData) {
      try {
        shopProducts = JSON.parse(productData.textContent || "[]").filter(function (product) {
          return product && product.title && product.url;
        });
      } catch {
        shopProducts = [];
      }
    }

    dialog.addEventListener("click", function (event) {
      var bounds = dialog.getBoundingClientRect();
      var outside = event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom;
      if (outside) dialog.close();
    });
    dialog.addEventListener("close", function () {
      document.documentElement.classList.remove("review-dialog-open");
      dialog.querySelectorAll("video").forEach(function (video) { video.pause(); });
      if (dialogTrigger && dialogTrigger.isConnected) dialogTrigger.focus();
      dialogTrigger = null;
    });
    dialog.addEventListener("cancel", function (event) {
      event.preventDefault();
      dialog.close();
    });
    dialog.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      event.preventDefault();
      dialog.close();
    });

    function createReviewMedia(review) {
      var items = Array.isArray(review.media) ? review.media : [];
      if (!showMedia || !items.length) return null;

      var gallery = document.createElement("div");
      gallery.className = "imported-review-media";
      gallery.setAttribute("data-media-count", String(items.length));

      items.forEach(function (item, index) {
        if (!item || !item.src) return;
        var frame = document.createElement("div");
        frame.className = "imported-review-media-item imported-review-media-item--" + item.type;

        if (item.type === "video") {
          var video = document.createElement("video");
          video.controls = true;
          video.preload = "metadata";
          video.playsInline = true;
          video.setAttribute("aria-label", "Customer video review of " + review.product);
          if (item.poster) video.poster = item.poster;
          var source = document.createElement("source");
          source.src = item.src;
          if (item.mime_type) source.type = item.mime_type;
          video.appendChild(source);
          frame.appendChild(video);
        } else {
          var mediaLink = document.createElement("a");
          mediaLink.href = item.src;
          mediaLink.target = "_blank";
          mediaLink.rel = "noopener";
          mediaLink.setAttribute("aria-label", "View customer photo " + (index + 1) + " of " + review.product + " at full size");
          var image = document.createElement("img");
          image.src = item.src;
          image.alt = "Customer photo review of " + review.product;
          image.loading = "lazy";
          image.decoding = "async";
          mediaLink.appendChild(image);
          frame.appendChild(mediaLink);
        }

        gallery.appendChild(frame);
      });

      return gallery.children.length ? gallery : null;
    }

    function createReviewCopy(review) {
      var quote = "“" + review.text + "”";
      if (review.text.length <= 96) return textNode("p", "imported-review-text", quote);

      var details = document.createElement("details");
      details.className = "imported-review-copy";
      var summaryNode = document.createElement("summary");
      summaryNode.setAttribute("aria-label", readMoreLabel + ": " + review.text);
      summaryNode.appendChild(textNode("span", "imported-review-summary-text", quote));
      summaryNode.appendChild(textNode("span", "imported-review-summary-icon", "+"));
      details.appendChild(summaryNode);
      details.appendChild(textNode("p", "imported-review-text imported-review-text--expanded", quote));
      return details;
    }

    function createReviewedProduct(review, shopProduct) {
      if (!showProduct || !shopProduct) return null;
      var product = document.createElement("button");
      product.type = "button";
      product.className = "imported-review-product";
      product.setAttribute("aria-haspopup", "dialog");
      product.setAttribute("aria-label", productLabel + ": " + shopProduct.title);
      if (shopProduct.image) {
        var productImage = document.createElement("img");
        productImage.src = shopProduct.image;
        productImage.alt = "";
        productImage.loading = "lazy";
        productImage.decoding = "async";
        productImage.width = 56;
        productImage.height = 56;
        product.appendChild(productImage);
      }
      var productCopy = textNode("span", "imported-review-product-copy");
      productCopy.appendChild(textNode("small", "", productLabel));
      productCopy.appendChild(textNode("strong", "", shopProduct.title));
      product.appendChild(productCopy);
      product.appendChild(textNode("span", "imported-review-product-arrow", "↗"));
      product.addEventListener("click", function () {
        openReviewDialog(review, shopProduct);
      });
      return product;
    }

    function createDialogMedia(review) {
      var items = Array.isArray(review.media) ? review.media.filter(function (item) {
        return item && item.src;
      }) : [];
      if (!items.length) return null;

      var media = textNode("div", "imported-review-dialog-media");
      var item = items[0];
      if (item.type === "video") {
        var video = document.createElement("video");
        video.controls = true;
        video.preload = "metadata";
        video.playsInline = true;
        video.setAttribute("aria-label", "Customer video review of " + review.product);
        if (item.poster) video.poster = item.poster;
        var source = document.createElement("source");
        source.src = item.src;
        if (item.mime_type) source.type = item.mime_type;
        video.appendChild(source);
        media.appendChild(video);
      } else {
        var image = document.createElement("img");
        image.src = item.src;
        image.alt = "Customer photo review of " + review.product;
        image.decoding = "async";
        media.appendChild(image);
      }
      if (items.length > 1) {
        media.appendChild(textNode("span", "imported-review-dialog-count", "1 / " + items.length));
      }
      return media;
    }

    function createBagIcon() {
      var namespace = "http://www.w3.org/2000/svg";
      var icon = document.createElementNS(namespace, "svg");
      icon.setAttribute("viewBox", "0 0 20 20");
      icon.setAttribute("width", "17");
      icon.setAttribute("height", "17");
      icon.setAttribute("aria-hidden", "true");
      var path = document.createElementNS(namespace, "path");
      path.setAttribute("d", "M5.5 7.5h9l-.7 9h-7.6l-.7-9Zm2.5 0V5a2 2 0 0 1 4 0v2.5");
      path.setAttribute("fill", "none");
      path.setAttribute("stroke", "currentColor");
      path.setAttribute("stroke-linecap", "round");
      path.setAttribute("stroke-linejoin", "round");
      path.setAttribute("stroke-width", "1.4");
      icon.appendChild(path);
      return icon;
    }

    function createDialogProduct(shopProduct) {
      var dock = textNode("div", "imported-review-dialog-product");
      if (shopProduct.image) {
        var image = document.createElement("img");
        image.src = shopProduct.image;
        image.alt = "";
        image.loading = "eager";
        image.decoding = "async";
        image.width = 68;
        image.height = 68;
        dock.appendChild(image);
      }
      var copy = textNode("div", "imported-review-dialog-product-copy");
      copy.appendChild(textNode("small", "", productLabel));
      copy.appendChild(textNode("strong", "", shopProduct.title));
      var link = document.createElement("a");
      link.className = "imported-review-dialog-product-link";
      link.href = shopProduct.url;
      link.appendChild(createBagIcon());
      link.appendChild(document.createTextNode(viewProductLabel));
      copy.appendChild(link);
      dock.appendChild(copy);
      return dock;
    }

    function openReviewDialog(review, shopProduct) {
      dialogTrigger = document.activeElement;
      while (dialog.firstChild) dialog.removeChild(dialog.firstChild);
      var shell = textNode("div", "imported-review-dialog-shell");
      var modalMedia = createDialogMedia(review);
      if (modalMedia) shell.appendChild(modalMedia);
      else shell.classList.add("imported-review-dialog-shell--no-media");

      var close = textNode("button", "imported-review-dialog-close", "×");
      close.type = "button";
      close.setAttribute("aria-label", closeReviewLabel);
      close.addEventListener("click", function () { dialog.close(); });
      shell.appendChild(close);

      var content = textNode("div", "imported-review-dialog-content");
      var heading = textNode("div", "imported-review-dialog-heading");
      heading.appendChild(textNode("strong", "", review.author));
      if (review.verified) {
        heading.appendChild(verifiedBadge("span", "imported-review-dialog-verified", verifiedBadgeSrc, verifiedLabel));
      }
      content.appendChild(heading);
      var stars = textNode("span", "imported-review-dialog-stars", "★".repeat(review.rating) + "☆".repeat(5 - review.rating));
      stars.setAttribute("role", "img");
      stars.setAttribute("aria-label", review.rating + " out of 5 stars");
      content.appendChild(stars);
      content.appendChild(textNode("p", "imported-review-dialog-text", review.text));
      content.appendChild(createDialogProduct(shopProduct));
      shell.appendChild(content);
      dialog.appendChild(shell);
      document.documentElement.classList.add("review-dialog-open");
      dialog.showModal();
      close.focus();
    }

    function createCard(review, shopProduct) {
      var card = document.createElement("article");
      card.className = "imported-review-card";

      var media = createReviewMedia(review);
      if (media) card.appendChild(media);
      else card.classList.add("imported-review-card--no-media");

      var body = textNode("div", "imported-review-body");
      var head = textNode("div", "imported-review-head");
      var stars = textNode("span", "rating-stars", "★★★★★".slice(0, review.rating));
      stars.setAttribute("role", "img");
      stars.setAttribute("aria-label", review.rating + " out of 5 stars");
      head.appendChild(stars);
      if (review.verified && verifiedBadgeSrc) {
        head.appendChild(verifiedBadge("small", "imported-review-verified", verifiedBadgeSrc, verifiedLabel));
      }
      body.appendChild(head);
      body.appendChild(createReviewCopy(review));

      var reviewedProduct = createReviewedProduct(review, shopProduct);
      if (reviewedProduct) body.appendChild(reviewedProduct);

      var footer = textNode("div", "imported-review-footer");
      footer.appendChild(textNode("strong", "", review.author));
      body.appendChild(footer);
      card.appendChild(body);
      return card;
    }

    // Cuộn tới cuối lưới tự hiện thêm, nhưng chỉ vài đợt: cuộn vô hạn với 96
    // review sẽ chôn FAQ và footer nằm dưới. Hết đợt tự động thì nút tiếp quản.
    var autoSupported = "IntersectionObserver" in window;
    var autoLoadLimit = Number(section.getAttribute("data-auto-load-batches"));
    if (!isFinite(autoLoadLimit) || autoLoadLimit < 0) autoLoadLimit = 2;
    var autoLoadsUsed = 0;
    var autoObserver = null;

    function autoLoadAvailable() {
      return autoSupported && autoLoadsUsed < autoLoadLimit;
    }

    function stopAutoLoad() {
      if (!autoObserver) return;
      autoObserver.disconnect();
      autoObserver = null;
    }

    function showNext() {
      var nextCount = Math.min(visibleCount + (visibleCount ? batchCount : initialCount), reviews.length);
      var fragment = document.createDocumentFragment();
      reviews.slice(visibleCount, nextCount).forEach(function (review, index) {
        var shopProduct = shopProducts.length ? shopProducts[(visibleCount + index) % shopProducts.length] : null;
        fragment.appendChild(createCard(review, shopProduct));
      });
      grid.appendChild(fragment);
      visibleCount = nextCount;
      var done = visibleCount >= reviews.length;
      more.hidden = done || autoLoadAvailable();
      more.setAttribute("aria-label", "Show more reviews, " + (reviews.length - visibleCount) + " remaining");
      if (done) stopAutoLoad();
      // Lưới còn ngắn hơn màn hình thì chèn tiếp cho tới khi có gì để cuộn.
      if (!done && autoLoadAvailable() && grid.getBoundingClientRect().bottom < window.innerHeight) {
        autoLoadsUsed++;
        showNext();
      }
    }

    function watchGridEnd() {
      if (!autoSupported) return;
      autoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || visibleCount >= reviews.length) return;
            if (!autoLoadAvailable()) {
              stopAutoLoad();
              more.hidden = false;
              return;
            }
            autoLoadsUsed++;
            showNext();
          });
        },
        {rootMargin: "600px 0px"}
      );
      autoObserver.observe(more.parentNode || more);
    }

    fetch(section.getAttribute("data-reviews-url"), {credentials: "same-origin"})
      .then(function (response) {
        if (!response.ok) throw new Error("Review archive unavailable");
        return response.json();
      })
      .then(function (data) {
        reviews = Array.isArray(data.reviews) ? data.reviews.filter(function (review) {
          return review.rating === 4 || review.rating === 5;
        }) : [];
        if (!reviews.length) throw new Error("Review archive is empty");
        summary.textContent = data.source.aggregate_rating + " ★ · " + reviews.length + " reviews";
        status.hidden = true;
        showNext();
        more.addEventListener("click", showNext);
        watchGridEnd();
      })
      .catch(function () {
        status.textContent = "Customer reviews are temporarily unavailable.";
      });
  }

  function initializeImportedReviews(root) {
    root.querySelectorAll("[data-imported-reviews]").forEach(renderImportedReviews);
  }

  initializeImportedReviews(document);
  document.addEventListener("shopify:section:load", function (event) {
    initializeImportedReviews(event.target);
  });
})();

/* ----------------------------------------- Infinite scroll cho product grid */
(function () {
  "use strict";

  function setup(trigger) {
    if (trigger.hasAttribute("data-infinite-ready")) return;
    var section = trigger.closest("section");
    var grid = section && section.querySelector("[data-infinite-grid]");
    if (!grid) return;
    trigger.setAttribute("data-infinite-ready", "");

    var status = trigger.querySelector("[data-infinite-status]");
    var loadButton = trigger.querySelector("[data-infinite-load]");
    var countNode = trigger.querySelector("[data-infinite-count]");
    var total = Number(trigger.getAttribute("data-total")) || 0;
    var sectionId = trigger.getAttribute("data-section-id");
    var supported = "IntersectionObserver" in window && "fetch" in window && "DOMParser" in window;
    var loading = false;
    var observer = null;
    // Cuộn vô hạn không trần sẽ đẩy các section dưới (collection tiles, FAQ,
    // footer) ra ngoài tầm với. Hết quota tự động thì trả lại nút bấm tay.
    var autoLoadLimit = Number(trigger.getAttribute("data-auto-load-batches"));
    if (!isFinite(autoLoadLimit) || autoLoadLimit < 0) autoLoadLimit = 2;
    var autoLoadsUsed = 0;

    function say(message) {
      if (!status) return;
      status.textContent = message || "";
      status.hidden = !message;
    }

    function updateCount() {
      if (!countNode) return;
      countNode.textContent = total ? grid.children.length + " / " + total : String(grid.children.length);
    }

    function stop(message) {
      trigger.removeAttribute("data-next-url");
      if (observer) observer.disconnect();
      if (loadButton) loadButton.hidden = true;
      say(message);
    }

    function autoLoadAvailable() {
      return autoLoadsUsed < autoLoadLimit;
    }

    // Hết quota tự động thì ngừng quan sát và trao quyền cho nút, để người mua
    // tự quyết khi nào tải thêm thay vì bị lưới đẩy footer ra xa vô hạn.
    function handOverToButton() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (loadButton) loadButton.hidden = !trigger.getAttribute("data-next-url");
      say("");
    }

    // Không chạy được JS thì link "xem tất cả" là lối đi duy nhất; nút tải thêm
    // nằm im vì nó vô dụng khi không fetch được.
    if (!supported) return;

    function load() {
      var url = trigger.getAttribute("data-next-url");
      if (loading || !url) return;
      loading = true;
      if (loadButton) loadButton.disabled = true;
      say(trigger.getAttribute("data-loading-label"));

      fetch(url + (url.indexOf("?") === -1 ? "?" : "&") + "section_id=" + encodeURIComponent(sectionId), {
        credentials: "same-origin"
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Section request failed");
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var nextGrid = doc.querySelector("[data-infinite-grid]");
          var nextTrigger = doc.querySelector("[data-infinite-more]");
          var added = 0;

          if (nextGrid) {
            var fragment = document.createDocumentFragment();
            while (nextGrid.firstElementChild) {
              fragment.appendChild(nextGrid.firstElementChild);
              added += 1;
            }
            grid.appendChild(fragment);
          }

          loading = false;
          if (loadButton) loadButton.disabled = false;
          updateCount();
          var following = nextTrigger && nextTrigger.getAttribute("data-next-url");
          if (!added || !following) {
            stop(trigger.getAttribute("data-end-label"));
            return;
          }
          trigger.setAttribute("data-next-url", following);
          say("");
          if (!autoLoadAvailable()) {
            handOverToButton();
            return;
          }
          // Màn hình cao có thể vẫn thấy đáy lưới sau khi chèn: kiểm tra lại ngay.
          if (trigger.getBoundingClientRect().top < window.innerHeight) {
            autoLoadsUsed += 1;
            load();
          }
        })
        .catch(function () {
          // Fetch hỏng thì bỏ hẳn tải thêm tại chỗ; link "xem tất cả" vẫn ở đó.
          loading = false;
          stop("");
        });
    }

    updateCount();
    if (loadButton) {
      loadButton.hidden = !trigger.getAttribute("data-next-url");
      loadButton.addEventListener("click", load);
    }

    // Quota bằng 0 thì không quan sát cuộn nữa: mọi lần tải đều do người mua bấm.
    if (!autoLoadAvailable()) return;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!autoLoadAvailable()) {
            handOverToButton();
            return;
          }
          autoLoadsUsed += 1;
          load();
        });
      },
      {rootMargin: "600px 0px"}
    );
    observer.observe(trigger);
  }

  /* ------------------------------------------------ Bundle cross-sell price */
  // Select mang name="id" nên form tự gửi đúng variant kể cả khi không có JS;
  // ở đây chỉ đồng bộ giá hiển thị theo lựa chọn.
  function initializeBundlePrices(root) {
    root.querySelectorAll("[data-bundle-select]").forEach(function (select) {
      if (select.hasAttribute("data-bundle-ready")) return;
      select.setAttribute("data-bundle-ready", "");
      select.addEventListener("change", function () {
        var item = select.closest(".pdp-bundle-item");
        var priceLabel = item && item.querySelector("[data-bundle-price]");
        var option = select.options[select.selectedIndex];
        if (!priceLabel || !option) return;
        var price = option.getAttribute("data-price");
        if (price) priceLabel.textContent = price;
      });
    });
  }

  function initializeInfiniteGrids(root) {
    root.querySelectorAll("[data-infinite-more]").forEach(setup);
  }

  initializeInfiniteGrids(document);
  initializeBundlePrices(document);
  document.addEventListener("shopify:section:load", function (event) {
    initializeInfiniteGrids(event.target);
    initializeBundlePrices(event.target);
  });
})();

/* ------------------------------------------------------ Reveal on scroll */
(function () {
  "use strict";
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var supported = "IntersectionObserver" in window;
  var observer = supported ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-revealed");
        observer.unobserve(entry.target);
      }
    });
  }, {rootMargin: "0px 0px -8% 0px", threshold: 0.1}) : null;

  function prepare(target, delay) {
    if (target.hasAttribute("data-reveal-ready")) return;
    target.setAttribute("data-reveal-ready", "");
    if (reducedMotion || !supported) return;
    target.classList.add("reveal-item");
    if (delay) target.style.setProperty("--reveal-delay", delay + "s");
    observer.observe(target);
    // Lưới an toàn: nếu observer không chạy (bfcache, môi trường lạ) thì hiện.
    window.setTimeout(function () { target.classList.add("is-revealed"); }, 2500);
  }

  function initializeReveal(root) {
    root.querySelectorAll(".product-grid, .collection-tile-grid, .review-cards, .ritual-section ol").forEach(function (grid) {
      Array.prototype.forEach.call(grid.children, function (child, index) {
        prepare(child, (index % 4) * 0.08);
      });
    });
    root.querySelectorAll(".section-heading, .section-heading-inline, .editorial-copy, .contact-editorial-copy, .builder-intro, .review-quote, .manifesto-inner").forEach(function (node) {
      prepare(node, 0);
    });
  }

  initializeReveal(document);
  document.addEventListener("shopify:section:load", function (event) {
    initializeReveal(event.target);
  });
})();
